import type { SimpleChanges } from '@angular/core';
import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { getSecondsInDays } from '@core/time-legacy';
import { BadgeComponent, RtTooltip } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-overdue-candidate-badge',
  templateUrl: './overdue-candidate-badge.component.html',
  styleUrls: ['./overdue-candidate-badge.component.less'],
  imports: [BadgeComponent, RtTooltip, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    '[class]': '[fontSize(), borderRadius()]',
  },
})
export class OverdueCandidateBadgeComponent {
  public readonly overdueSeconds = input<number>(undefined!, { alias: 'overdueDiff' });
  public readonly hasTooltip = input<boolean>(undefined!);
  public readonly tooltipHideDelay = input<number>(300);
  public readonly fontSize = input<'font-size-small-xx' | 'font-size-default'>(
    'font-size-small-xx',
  );
  public readonly borderRadius = input<'border-radius' | 'border-radius-large'>('border-radius');

  public overdueDays: number = 0;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.overdueSeconds?.currentValue) {
      this.updateText();
    }
  }

  private updateText(overdueDiff = this.overdueSeconds()): void {
    const overdue = Math.abs(overdueDiff);
    this.overdueDays = Math.ceil(getSecondsInDays(overdue));
  }
}
